(() => {
  'use strict';
  if (window.AvonticPurchasePath) return;
  const states = new Map();
  const experiment = 'tablet_purchase_path_20260930';
  const parse = node => { try { return JSON.parse(node?.textContent || 'null'); } catch { return null; } };
  const put = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const track = (action, root, extra = {}) => window.AvonticAnalytics?.track?.('av_purchase_path_step', {
    component: 'tablet_purchase_path', experiment_id: experiment, experiment_variant: 'focused', action,
    product_id: root?.dataset.avPurchaseProduct, product_handle: root?.dataset.avPurchaseHandle,
    surface: root ? 'product_page' : 'cart', ...extra
  });
  function context() {
    const root = document.querySelector('[data-av-purchase-product]');
    const picker = root?.querySelector('variant-picker');
    const field = [...(picker?.querySelectorAll('[data-av-explicit-selection-option]') || [])].find(el =>
      /model|size|device|generation/i.test(el.dataset.avExplicitSelectionName || '') && !/keyboard|pack|quantity/i.test(el.dataset.avExplicitSelectionName || ''));
    if (!field) return null;
    const menu = document.getElementById(field.querySelector('button[aria-controls]')?.getAttribute('aria-controls'));
    const input = (menu || field).querySelector('input[data-option-position]:checked') || field.querySelector('select[data-option-position]');
    const form = document.getElementById(picker.getAttribute('form-id'));
    const variant = parse(picker.querySelector('script[data-variant]'));
    const name = root.dataset.avPurchaseFamily === 'ipad' ? 'iPad' : root.dataset.avPurchaseFamily === 'galaxy-tablet' ? 'Galaxy Tab' : 'Surface';
    return {root,picker,field,menu,input,form,variant,name,id:root.dataset.avPurchaseProduct};
  }
  function state(c) {
    if (!states.has(c.id)) {
      const params = new URLSearchParams(location.search);
      const directVariant = params.get('variant') && String(c.variant?.id) === params.get('variant');
      const directOptions = params.get('option_values')?.split(',').includes(String(c.input?.value));
      // Only an actual matching deep link is treated as an intentional initial choice.
      states.set(c.id,{choice:(directVariant || directOptions) ? c.input?.value : '', announced:false, initialized:true});
    }
    return states.get(c.id);
  }
  function hasChoice(c) {
    return Boolean(c?.input && String(state(c).choice) === String(c.input.value));
  }
  function ready(c) {
    // The gate only confirms that the shopper actively chose a model. It never
    // compares editorial display labels, and it fails open when verification data
    // is missing so a chosen, available model can always be added to the cart.
    if (!hasChoice(c) || !c.form) return false;
    if (!c.variant) return false; // no variant for this combination: keep the "unavailable" message
    const idInput = c.form.querySelector('input[name="id"]');
    const idValue = String(idInput?.value || '');
    if (idValue && idValue !== String(c.variant.id)) return false; // form still updating to the new variant
    const position = Number(c.input?.dataset.optionPosition || 0);
    const original = c.input?.matches?.('select') ? c.input.selectedOptions?.[0]?.dataset.avOptionName : c.input?.dataset.avOptionName;
    if (typeof original === 'string' && position > 0 && Array.isArray(c.variant.options) && c.variant.options[position - 1] !== undefined) {
      return original === c.variant.options[position - 1];
    }
    return true;
  }
  function blockUnready(c) {
    if (!hasChoice(c)) requestModel(c);
    else put(c.root.querySelector('[data-av-purchase-status]'), c.variant ? 'Updating your selection. Please try again in a moment.' : 'This combination is unavailable. Choose another option.');
  }
  function choose(c, value, reason) {
    if (!c || !value) return;
    const s = state(c); s.choice = String(value); s.announced = false;
    track('model_selected',c.root,{compatibility_key:String(value),reason});
    schedule();
    // Choosing the already-checked option does not fire a native change event.
    // Close the menu explicitly so that selection is still a complete interaction.
    if (reason === 'manual') queueMicrotask(() => {
      const trigger=c.field.querySelector('button[aria-controls]');
      if(trigger?.isConnected&&trigger.getAttribute('aria-expanded')==='true')trigger.click();
    });
  }
  function requestModel(c) {
    if (!c) return;
    const button = c.field.querySelector('button[aria-controls]');
    c.field.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
    button?.focus({preventScroll:true});
    if (button?.getAttribute('aria-expanded') !== 'true') button?.click();
    put(c.root.querySelector('[data-av-purchase-status]'),`Choose your exact ${c.name} to continue.`);
    track('model_required',c.root);
  }
  function updateOfferNote(c) {
    const box=c.root.querySelector('[data-av-purchase-offers]');
    if(!box) return;
    const note=box.querySelector('[data-av-purchase-offer-note]');
    put(note,!ready(c)?`Choose your ${c.name} above to see matching setups.`:'Explore the setups below, then confirm your model and finish.');
  }
  function render() {
    const c=context(); if(!c) return;
    const valid=ready(c), chosen=hasChoice(c), s=state(c);
    c.root.dataset.avPurchaseFit=valid?'selected':'pending';
    c.field.dataset.avPurchaseModel='true';
    const trigger=c.field.querySelector('button[aria-controls]');
    const label=trigger?.querySelector('span[id$="-selected-value"]');
    const selectedLabel=c.input?.id ? document.querySelector(`label[for="${CSS.escape(c.input.id)}"]`) : null;
    if(label) {
      if(!label.dataset.avPurchaseOriginal) label.dataset.avPurchaseOriginal=label.textContent.trim();
      const chosenLabel=selectedLabel?.querySelector('span')?.textContent.trim() || label.dataset.avPurchaseOriginal;
      put(label,chosen?chosenLabel:`Choose your ${c.name} model`);
    }
    trigger?.setAttribute('aria-describedby',`AvPurchaseStatus-${c.id}`);
    const status=c.root.querySelector('[data-av-purchase-status]');
    if(status) status.id=`AvPurchaseStatus-${c.id}`;
    put(status,!chosen?'Choose your exact model, then your finish.':valid?`${c.name} selected. Choose your finish below.`:c.variant?'Updating your selection…':'This combination is unavailable. Choose another option.');
    const badge=c.field.querySelector('.av-pdp-required-badge');
    if(!c.field.hasAttribute('data-av14-fit-confirmed')) put(badge,chosen?'Model selected':'Start here');
    const primary=c.form?.querySelector('[data-av-atc-control]');
    // A named input "id" masks form.id; use the attribute for sticky-form association.
    const formId=c.form?.getAttribute('id');
    const sticky=[...document.querySelectorAll('.av-pdp-sticky-cockpit [data-av-atc-control]')].filter(el=>formId && (el.getAttribute('form')===formId || el.closest('[form]')?.getAttribute('form')===formId));
    sticky.forEach(button=>{
      const bar=button.closest('product-sticky-bar');
      put(bar?.querySelector('.av-pdp-sticky__options'),chosen?(c.variant?.options||[]).join(' · '):`Select your ${c.name} model`);
      put(bar?.querySelector('.av-pdp-sticky__state'),!chosen?'Model required':!valid?'Updating selection…':c.variant?.available?'Available':'Sold out');
    });
    [primary,...sticky].filter(Boolean).forEach(button=>{
      if(!valid && !button.disabled){
        button.dataset.avPurchaseGated='true';
        put(button,chosen?'Updating selection…':`Choose your ${c.name}`);
      } else if(button.dataset.avPurchaseGated==='true') {
        delete button.dataset.avPurchaseGated;
        if(!button.disabled && c.variant?.available) {
          const text=c.form.querySelector('buy-buttons')?.dataset.avAtcLabelAvailable || 'Add to cart';
          // Quantity-aware pricing is shown beside the selector, never as a unit price inside the action.
          put(button,text);
        }
      }
    });
    if(c.form) c.form.dataset.avPurchaseFit=valid?'selected':'pending';
    if(!valid) c.root.querySelectorAll('[data-av-payment-wrapper]').forEach(el=>{el.dataset.avPurchaseHidden='true';el.hidden=true;el.inert=true;});
    else c.root.querySelectorAll('[data-av-payment-wrapper][data-av-purchase-hidden]').forEach(el=>{delete el.dataset.avPurchaseHidden;if(c.variant?.available&&!el.hasAttribute('data-av-inventory-hidden')){el.hidden=false;el.inert=false;}});
    updateOfferNote(c);
    if(valid&&!s.announced){s.announced=true;document.dispatchEvent(new CustomEvent('avontic:purchase-fit-ready'));}
  }
  let queued=false;
  function schedule(){if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;render();});}}
  // Capture both pointer and keyboard form submissions before the theme's AJAX cart handler.
  document.addEventListener('submit',event=>{
    const c=context();if(!c||event.target!==c.form)return;
    if(!ready(c)){event.preventDefault();event.stopImmediatePropagation();blockUnready(c);}
    else track('add_to_cart_intent',c.root,{variant_id:String(c.variant?.id||'')});
  },true);
  document.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target:null;
    const c=context();
    if(c){
      const atc=target?.closest('[data-av-atc-control]');
      if(atc&&(c.form?.contains(atc)||atc.closest('.av-pdp-sticky-cockpit'))&&!ready(c)){
        event.preventDefault();event.stopImmediatePropagation();blockUnready(c);return;
      }
      const offer=target?.closest('[data-av-purchase-offer]');
      if(offer){
        if(!ready(c)){event.preventDefault();event.stopImmediatePropagation();blockUnready(c);return;}
        // Setup cards open a review dialog; that dialog validates the final variant before navigation.
        track('bundle_selected',c.root,{destination:offer.href,recommended_variant_id:offer.dataset.av135Variant});
      }
      const input=target?.matches('input[data-option-position]')?target:null;
      if(input&&(c.field.contains(input)||c.menu?.contains(input))&&event.isTrusted) choose(c,input.value,'manual');
    }
    const checkout=target?.closest('.avc-drawer-footer button[name="checkout"],.av-cart-experience button[name="checkout"]');
    if(checkout) track('checkout_intent',null,{surface:checkout.closest('.avc-drawer-footer')?'cart_drawer':'cart_page'});
  },true);
  document.addEventListener('change',event=>{
    const c=context(),input=event.target;
    if(c&&input instanceof Element&&(c.field.contains(input)||c.menu?.contains(input))&&input.matches('[data-option-position]')&&event.isTrusted)choose(c,input.value,'manual');
    schedule();
  },true);
  document.addEventListener('keydown',event=>{
    if(!event.isTrusted||![' ','Enter'].includes(event.key))return;
    const c=context(),input=event.target;
    if(c&&input instanceof Element&&input.matches('input[data-option-position]')&&(c.field.contains(input)||c.menu?.contains(input))){
      event.preventDefault();choose(c,input.value,'manual');input.click();
    }
  },true);
  document.addEventListener('avontic:pdp-fit-verification',event=>{
    const c=context();
    if(!c||String(event.detail?.productId)!==c.id)return;
    if(event.detail.verified)choose(c,c.input?.value,'model_finder');
    else {
      const s=state(c);s.choice='';s.announced=false;
      schedule();
    }
  });
  document.addEventListener('avontic:purchase-offer-quoted',()=>{const c=context();if(c)updateOfferNote(c);});
  ['variant:change','product:rerender','shopify:section:load'].forEach(name=>document.addEventListener(name,schedule));
  window.addEventListener('pageshow',schedule);
  document.addEventListener('toggle',event=>{if(event.target.matches?.('.av-purchase-cart-extra')&&event.target.open)track('cart_extras_opened',null);},true);
  function start(){
    render();
    new MutationObserver(records=>{
      if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-av-purchase-product],variant-picker,product-form,product-sticky-bar')||n.querySelector('[data-av-purchase-product],variant-picker,product-form,product-sticky-bar')))))schedule();
    }).observe(document.body,{childList:true,subtree:true});
  }
  window.AvonticPurchasePath=Object.freeze({version:'2026-09-30.5',ready:()=>{const c=context();return !c||ready(c);}});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

